<template>
  <v-list class="graylist ma-0 pa-0">
    <div v-for="(qtm,idx) in filteredQTMs" :key="idx">
      <v-list-item :class="displayButtons === true ? '' : 'pt-4'" :three-line="displayButtons === true" :two-line="displayButtons === false">
        <v-list-item-content>
          <p v-html='$t("labels.employment-rate-text", {
            name: studentName,
            percent: convertToPercentage(qtm, "employmentRate"),
            period: formatInterval(qtm),
            originalPercent: convertToPercentage(qtm, "originalEmploymentRate")
          })'></p>
        </v-list-item-content>
        <template  v-if="qtm.id && displayButtons === true">
          <v-list-item-action class="d-none d-sm-block">
              <ActionButton actionIcon="$sl-edit" :block="false" @click="editRow(qtm.id)">{{ $t("labels.edit") }}</ActionButton>
              <ActionButton class="ml-2" actionIcon="$sl-delete" :block="false" @click="deleteRow(qtm.id)">{{ $t("labels.delete") }}</ActionButton>
          </v-list-item-action>
          <v-list-item-action class="ml-1 d-block d-sm-none">
              <v-btn class="btn-label" x-small icon @click="editRow(qtm.id)"><v-icon>$sl-edit</v-icon></v-btn>
              <v-btn x-small icon @click="deleteRow(qtm.id)"><v-icon>$sl-delete</v-icon></v-btn>
          </v-list-item-action>
        </template>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
import API from '@/services/api.js'
import get from 'lodash/get'
import filter from 'lodash/filter'
import ActionButton from '@/components/Common/ActionButton'

// @group Company
// QualificationTimeModificationList component
export default {
  name: 'QualificationTimeModificationList',
  props: {
    studentName: {
      type: String,
      default: ''
    },
    educationId: {
      type: Number,
      default: 0
    },
    displayButtons: {
      type: Boolean,
      default: true
    },
    renderKey: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    qualificationTimeModifications: []
  }),

  components: {
    ActionButton,
  },

  created() {
    this.init()
  },

  watch: {
    renderKey: {
      handler() {
        this.init();
      }
    }
  },

  computed: {
    filteredQTMs() {
      return filter(this.qualificationTimeModifications, o => o.employmentRate>0)
    }
  },

  methods: {

    init() {
      API.listQualificationTimeModifications(this.educationId).then(res => {
        this.qualificationTimeModifications = res.data
      })
      .catch(() => this.qualificationTimeModifications = [])
    },

    convertToPercentage(qtm, field) {
      const employmentRate = get(qtm, field, 1.0)
      return employmentRate * 100.0
    },

    formatInterval(qtm) {
      if(qtm.fromDate && qtm.toDate) {
        return `${new Date(qtm.fromDate).toISOString().substr(0, 10)} - ${new Date(qtm.toDate).toISOString().substr(0, 10)}`
      }

      return ''
    },

    editRow(id) {
      const qtm = this.qualificationTimeModifications.find(qtm => qtm.id === id)

      this.$emit("openModal", qtm)
    },

    deleteRow(id) {
      API.deleteBookPause(id)
        .then(res => {
          let index = this.qualificationTimeModifications.findIndex(qtm => qtm.id === id)
          this.qualificationTimeModifications.splice(index, 1)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

